<template>
  <VirtualLoadTracking v-if="meterModel == 0" />
  <EntityLoadTracking v-if="meterModel == 1" />
</template>

<script setup>
import { computed } from 'vue'

import VirtualLoadTracking from './virtualLoadTracking.vue'
import EntityLoadTracking from './entityLoadTracking.vue'

import { useAppStore } from "@/store/modules/app";

const stationId = computed(() => {
  return useAppStore().stationId
})

const meterModel = computed(() => {
  return useAppStore().getMeterModel(stationId.value)
})
</script>